import { memo } from 'react';
import { withAnalyticsEvents } from '@atlaskit/analytics-next';
import { CommandShortcuts as Shortcuts } from '@atlassian/jira-command-palette-common/src/ui/command-shortcuts/index.tsx';
import { keyboardShortcutPressed } from '@atlassian/jira-common-navigation/src/keyboard-shortcuts/analytics.tsx';
import withInjectedProps from '@atlassian/jira-common-util-with-injected-props/src/index.tsx';
import { UIControllerSubscriber as NavUIControllerSubscriber } from '@atlassian/jira-navigation-next-bridge/src/controllers/navigation-ui-controller/index.tsx';
import { ProjectCreateDrawerConsumer } from '@atlassian/jira-project-create-drawer-context/src/index.tsx';
import { ApplicationPermissionsSubscriber } from '@atlassian/jira-tenant-context-controller/src/components/application-permissions/index.tsx';
import { navigateToIssueSearch, navigateToMostRecentProject } from '../ops/index.tsx';
import { KeyboardShortcutsDialog } from './dialog/index.tsx';
import KeyboardShortcuts from './view.tsx';

/* Using withAnalyticsEvents HOC instead of ComponentWithAnalytics so we can fire on the
 * navigation channel and add actionSubjectId and attributes easily.
 * The withAnalyticsEvents HOC must wrap keyboardShortcuts first so it does not override any injected
 * props. */
export default memo(
	withInjectedProps(
		withAnalyticsEvents({
			showSearch: (createAnalyticsEvent) =>
				keyboardShortcutPressed({ createAnalyticsEvent, id: 'quickSearch', key: '/' }),
			showIssueCreate: (createAnalyticsEvent) =>
				keyboardShortcutPressed({ createAnalyticsEvent, id: 'createIssue', key: 'c' }),
			navigateToIssueSearch: (createAnalyticsEvent) =>
				keyboardShortcutPressed({ createAnalyticsEvent, id: 'findIssues', key: 'g i' }),
			navigateToMostRecentProject: (createAnalyticsEvent) =>
				keyboardShortcutPressed({ createAnalyticsEvent, id: 'browseToProject', key: 'g p' }),
		})(KeyboardShortcuts),
		{
			navigateToIssueSearch,
			navigateToMostRecentProject,
			ApplicationPermissionsSubscriber,
			KeyboardShortcutsDialog,
			ProjectCreateDrawerConsumer,
			Shortcuts,
			NavUIControllerSubscriber,
		},
	),
);
